var _style, _rect, _g, _path, _path2, _rect2, _path3, _rect3, _path4, _ellipse, _path5, _path6, _path7, _path8, _ellipse2, _path9, _path10, _rect4, _rect5, _rect6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _line, _line2, _path18, _path19, _path20, _path21, _path22, _ellipse3, _path23, _path24, _path25, _path26, _g2, _path27, _path28, _path29, _path30, _g3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#747D7A;}\n\t.st1{fill:#EEF2F4;}\n\t.st2{opacity:0.34;}\n\t.st3{fill:#65706C;}\n\t.st4{fill:#2F262D;}\n\t.st5{fill:#FC9F6F;}\n\t.st6{fill:#F2F2F2;}\n\t.st7{fill:#3B323A;}\n\t.st8{fill:#AFAFAF;}\n\t.st9{fill:#EF9067;}\n\t.st10{fill:#603936;}\n\t.st11{fill:#F05364;}\n\t.st12{fill:#494149;}\n\t.st13{opacity:0.71;fill:#D36B46;}\n\t.st14{fill:#DD9883;}\n\t.st15{fill:none;stroke:#DD9883;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{opacity:0.6;fill:#EF9067;}\n\t.st17{fill:none;stroke:#F6CDF7;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FCFAFA;}\n\t.st19{fill:none;stroke:#161515;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:#754743;}\n\t.st21{fill:#F4EFF0;}\n\t.st22{fill:#FFFFFF;}\n\t.st23{fill:#E2E2E2;}\n\t.st24{fill:#352934;}\n\t.st25{fill:#CECECE;}\n\t.st26{fill:#535452;}\n\t.st27{fill:#FFFDFD;}\n\t.st28{fill:#424441;}\n\t.st29{fill:#FF6161;}\n\t.st30{fill:#F4A36C;}\n\t.st31{fill:#F7BC8B;}\n\t.st32{fill:#EFA573;}\n\t.st33{opacity:0.77;fill:#F2F2F2;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: 0,
    className: "st0",
    width: 1000,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.2,959.2c0,2.5-1.2,3.7-2.6,3.7c-1.1,0-1.9-0.5-2.1-1.4c-0.4,0.5-1,0.8-1.8,0.8c-1.5,0-2.6-1.2-2.6-2.8 c0-1.6,1.1-2.8,2.6-2.8c0.7,0,1.2,0.3,1.6,0.7v-0.5h1.6v3.9c0,0.8,0.3,1.4,1,1.4c0.9,0,1.7-0.9,1.7-3c0-3-2.3-5.3-5.4-5.3 c-3.1,0-5.6,2.4-5.6,5.7c0,3.3,2.5,5.7,5.9,5.7c1.1,0,2.1-0.2,2.9-0.4v0.6c-0.8,0.3-1.7,0.4-2.9,0.4c-3.7,0-6.5-2.6-6.5-6.2 c0-3.4,2.7-6.2,6.2-6.2C61.1,953.3,63.2,956.4,63.2,959.2z M58.3,959.5c0-0.8-0.6-1.4-1.3-1.4c-0.8,0-1.3,0.5-1.3,1.4 c0,0.8,0.6,1.3,1.3,1.3C57.8,960.9,58.3,960.3,58.3,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,955.1v2c-1.2-0.1-2.6,0.5-2.6,2.4v4.3h-1.9v-8.6h1.9v1.4C67.3,955.5,68.3,955.1,69.4,955.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.6,962.3c1,0,1.8-0.5,2.2-1.1l1.5,0.9c-0.8,1.2-2.1,1.9-3.8,1.9c-2.8,0-4.7-1.9-4.7-4.5 c0-2.5,1.8-4.5,4.5-4.5c2.6,0,4.3,2.1,4.3,4.5c0,0.3,0,0.5-0.1,0.8h-6.8C72.1,961.6,73.2,962.3,74.6,962.3z M76.9,958.8 c-0.3-1.5-1.3-2.1-2.5-2.1c-1.4,0-2.3,0.8-2.6,2.1H76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,955.2v8.6h-1.9v-1.2c-0.7,0.9-1.7,1.5-3,1.5c-2.3,0-4.3-2-4.3-4.5c0-2.6,1.9-4.5,4.3-4.5 c1.3,0,2.3,0.5,3,1.4v-1.2H88.9z M87.1,959.5c0-1.6-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.1-2.7,2.7c0,1.6,1.2,2.7,2.7,2.7 C85.9,962.3,87.1,961.1,87.1,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.1,951.3H93v12.5h-1.9V951.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,955.2l-3.3,8.6h-2.1l-3.3-8.6h2l2.4,6.5l2.4-6.5H102.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,955.2h1.9v8.9c0,2.4-1.2,3.5-3.5,3.3v-1.8c1.1,0.1,1.7-0.3,1.7-1.5V955.2z M104,952.8 c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2C104.5,954,104,953.4,104,952.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116,955.2l-3.3,8.8c-0.8,2.2-2.2,3.3-4.2,3.2v-1.7c1.2,0.1,1.9-0.5,2.3-1.7l0.1-0.2l-3.6-8.4h2l2.6,6.2 l2.2-6.2H116z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C210.4,934.9,211.9,936.6,211.9,938.7z M210.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C209.8,941.6,210.9,940.3,210.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.5,940.8h-3.4l-0.6,1.7h-1.1l2.8-7.6h1.1l2.8,7.6h-1.1L219.5,940.8z M219.2,939.9l-1.4-3.8l-1.4,3.8 H219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L226.4,939.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.5,934.9v7.6h-1V936l-1.6,0.5l-0.3-0.9l2-0.7H239.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.1,940.3c0,1.5-1.2,2.4-2.6,2.4c-1.1,0-2.1-0.5-2.5-1.5l0.9-0.5c0.2,0.7,0.8,1.1,1.7,1.1 c0.9,0,1.6-0.5,1.6-1.4c0-0.9-0.7-1.4-1.6-1.4h-0.3l-0.4-0.6l1.8-2.4h-3.4v-0.9h4.6v0.9l-1.7,2.2 C247.2,938.2,248.1,939,248.1,940.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C57.4,934.9,58.9,936.6,58.9,938.7z M57.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C56.8,941.6,57.9,940.3,57.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70,940.8l0.9-0.5c0.3,0.8,0.9,1.4,2,1.4c1.1,0,1.6-0.5,1.6-1.2c0-0.8-0.7-1-1.8-1.4 c-1.2-0.4-2.4-0.8-2.4-2.2c0-1.4,1.1-2.2,2.4-2.2c1.3,0,2.2,0.7,2.6,1.7l-0.8,0.5c-0.3-0.7-0.8-1.2-1.7-1.2 c-0.8,0-1.4,0.4-1.4,1.1c0,0.7,0.5,1,1.6,1.3c1.3,0.4,2.6,0.8,2.6,2.3c0,1.3-1.1,2.2-2.6,2.2C71.5,942.7,70.4,941.9,70,940.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,934.9v7.6h-1v-7.6H80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.3,939.2c0,1.9-1.4,3.5-3.7,3.5c-2.4,0-4-1.8-4-4c0-2.2,1.7-4,4-4c1.4,0,2.7,0.8,3.3,1.8l-0.9,0.5 c-0.4-0.8-1.4-1.4-2.4-1.4c-1.8,0-3,1.3-3,3c0,1.7,1.2,3,3,3c1.6,0,2.5-0.9,2.7-2h-2.8v-0.9h3.8V939.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.6,934.9v7.6h-0.8l-3.9-5.7v5.7h-1v-7.6h0.8l3.9,5.7v-5.7H100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.1,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.2,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C117.6,934.9,119.2,936.6,119.2,938.7z M118.2,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C117.1,941.6,118.2,940.3,118.2,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.2,940.4c0,1.2-1,2.2-2.2,2.2h-3.3v-7.6h3c1.2,0,2.1,0.9,2.1,2.1c0,0.7-0.3,1.2-0.8,1.6 C132.7,938.9,133.2,939.5,133.2,940.4z M128.7,935.8v2.3h2c0.6,0,1.1-0.5,1.1-1.2c0-0.6-0.5-1.2-1.1-1.2H128.7z M132.2,940.3 c0-0.7-0.5-1.2-1.2-1.2h-2.3v2.5h2.3C131.7,941.6,132.2,941,132.2,940.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L139.4,939.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.5,951.9v12.4h-2v-12.4H207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218,953.9h-3.5v10.4h-2v-10.4H209v-1.9h9V953.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236,958.7c0,3.4-2.4,5.8-6.1,5.8c-3.9,0-6.6-2.9-6.6-6.4s2.8-6.4,6.5-6.4c2.4,0,4.4,1.2,5.4,2.9l-1.8,1 c-0.6-1.2-2-2-3.6-2c-2.6,0-4.5,1.9-4.5,4.5c0,2.5,1.8,4.4,4.6,4.4c2.2,0,3.6-1.2,4-2.8h-4.1v-1.8h6.2V958.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.5,952.9c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2 C238,954.1,237.5,953.6,237.5,952.9z M237.8,955.4h1.9v8.9h-1.9V955.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.5,955.3v2.1c-1.3-0.1-2.7,0.5-2.7,2.5v4.5h-1.9v-8.9h1.9v1.5C244.3,955.7,245.4,955.3,246.5,955.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.9,951.4h1.9v12.9h-1.9V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M841.3,942.5h-1v-7.6h1.1l2.4,4l2.4-4h1.1v7.6h-1v-6l-2.5,4.2h-0.1l-2.5-4.1V942.5z M858.8,938.7 c0,2.2-1.7,4-4,4c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-4,3.9-4C857.1,934.7,858.8,936.5,858.8,938.7z M857.8,938.7c0-1.7-1.3-3-2.9-3 c-1.7,0-2.9,1.3-2.9,3c0,1.7,1.3,3,2.9,3C856.6,941.7,857.8,940.4,857.8,938.7z M866.2,939.5l1.8,3.1h-1.1l-1.7-2.9h-1.8v2.9h-1 v-7.6h3c1.3,0,2.4,1.1,2.4,2.4C867.8,938.2,867.1,939.1,866.2,939.5z M865.4,938.7c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4 h-2v2.8H865.4z M875.9,941.6h-3.5v-2.4h3.2v-0.9h-3.2v-2.3h3.5v-1h-4.5v7.6h4.6V941.6z M844.2,962.2l-2.5-6.7h-2.1l3.5,8.9h2.2 l3.5-8.9h-2.1L844.2,962.2z M850,964.3h1.9v-8.9H850V964.3z M851,951.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2 c0.7,0,1.2-0.6,1.2-1.2C852.2,952.2,851.6,951.7,851,951.7z M855.2,951.7c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2 c0.7,0,1.2-0.6,1.2-1.2C856.5,952.2,855.9,951.7,855.2,951.7z M854.3,964.7c0,1.2-0.5,1.7-1.7,1.6v1.8c2.4,0.2,3.6-1,3.6-3.4v-9.2 h-1.9V964.7z M865.4,955.4h1.9v8.9h-1.9V963c-0.7,0.9-1.7,1.5-3.1,1.5c-2.4,0-4.4-2-4.4-4.7c0-2.6,2-4.7,4.4-4.7 c1.4,0,2.4,0.6,3.1,1.5V955.4z M865.4,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 C864.2,962.7,865.4,961.5,865.4,959.9z M873.3,961.9l-2.6-6.4h-2.1l3.8,8.7l-0.1,0.2c-0.4,1.2-1.1,1.8-2.4,1.7v1.8 c2,0.1,3.5-1,4.3-3.3l3.4-9.1h-2L873.3,961.9z M882.3,962.2l-2.5-6.7h-2.1l3.5,8.9h2.2l3.5-8.9h-2.1L882.3,962.2z M896.4,959.9 c0,0.3,0,0.5-0.1,0.8h-7c0.3,1.4,1.4,2.1,2.8,2.1c1.1,0,1.9-0.5,2.3-1.1l1.6,0.9c-0.8,1.2-2.1,1.9-3.9,1.9c-2.9,0-4.8-2-4.8-4.7 c0-2.6,1.9-4.7,4.7-4.7C894.5,955.2,896.4,957.3,896.4,959.9z M894.4,959.1c-0.3-1.5-1.4-2.2-2.5-2.2c-1.4,0-2.4,0.8-2.7,2.2 H894.4z M899.9,956.9v-1.5H898v8.9h1.9v-4.5c0-2,1.5-2.6,2.7-2.5v-2.1C901.6,955.3,900.5,955.7,899.9,956.9z M913.8,955.2 c-1.2,0-2.1,0.5-2.7,1.4c-0.5-0.9-1.4-1.4-2.5-1.4c-1.1,0-2,0.4-2.5,1.3v-1.1h-1.9v8.9h1.9v-5c0-1.6,0.9-2.3,2-2.3 c1,0,1.7,0.7,1.7,1.9v5.4h1.9v-5c0-1.6,0.8-2.3,1.9-2.3c1,0,1.7,0.7,1.7,1.9v5.4h1.9v-5.5C917.1,956.6,915.8,955.2,913.8,955.2z  M926.2,955.4h1.9v8.9h-1.9V963c-0.7,0.9-1.7,1.5-3.1,1.5c-2.4,0-4.4-2-4.4-4.7c0-2.6,2-4.7,4.4-4.7c1.4,0,2.4,0.6,3.1,1.5V955.4z  M926.2,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8C925,962.7,926.2,961.5,926.2,959.9z  M931.5,961.9c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3C932.8,962.4,932.2,961.9,931.5,961.9z  M938.3,962.6c-1.6,0-2.7-1.2-2.7-2.8c0-1.6,1.2-2.8,2.7-2.8c1.1,0,1.9,0.5,2.3,1.4l1.6-1c-0.7-1.4-2.2-2.3-3.9-2.3 c-2.7,0-4.7,2-4.7,4.7c0,2.6,2,4.7,4.7,4.7c1.7,0,3.2-0.9,4-2.3l-1.6-0.9C940.2,962.1,939.3,962.6,938.3,962.6z M952.4,959.9 c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7C950.3,955.2,952.4,957.2,952.4,959.9z M950.5,959.9 c0-1.6-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8S950.5,961.5,950.5,959.9z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st2",
    d: "M826.5,817.9H207.3c-7.9,0-14.3-6.4-14.3-14.3l0,0c0-7.9,6.4-14.3,14.3-14.3h619.2 c7.9,0,14.3,6.4,14.3,14.3l0,0C840.8,811.5,834.4,817.9,826.5,817.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st3",
    d: "M872,629.5H746.1c-12.8,0-23.2-10.4-23.2-23.2v0c0-12.8,10.4-23.2,23.2-23.2h70.3 c15.2,0,27.5-12.3,27.5-27.5v0c0-15.2-12.3-27.5-27.5-27.5h-62.5c-17.1,0-31-13.9-31-31v0c0-17.1,13.9-31,31-31h69.5 c15.2,0,27.6-12.4,27.6-27.6v0c0-15.2-12.4-27.6-27.6-27.6H723h-24c-15.2,0-27.6-12.4-27.6-27.6v0c0-15.2,12.4-27.6,27.6-27.6h27.2 c15.2,0,27.6-12.4,27.6-27.6v0c0-15.2-12.4-27.6-27.6-27.6h-15.5h-2.6H543.8h-5.6H366.6h-39.3c-15.2,0-27.6,12.4-27.6,27.6v0 c0,15.2,12.4,27.6,27.6,27.6H339c15.2,0,27.6,12.4,27.6,27.6v0c0,15.2-12.4,27.6-27.6,27.6H233.7c-11.7,0-21.2,9.5-21.2,21.2v0 c0,11.7,9.5,21.2,21.2,21.2h110.9c12.2,0,22.1,9.9,22.1,22.1v0c0,12.2-9.9,22.1-22.1,22.1h-177c-15.2,0-27.6,12.4-27.6,27.6v0 c0,15.2,12.4,27.6,27.6,27.6H339c15.2,0,27.6,12.4,27.6,27.6v0c0,15.2-12.4,27.6-27.6,27.6H235.5c-24.4,0-44.2,19.8-44.2,44.2v0 c0,24.4,19.8,44.2,44.2,44.2h131.1h58.2h32.7H723h149c18.4,0,33.3-14.9,33.3-33.3v0C905.3,644.4,890.4,629.5,872,629.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_114_",
    x: 638.4,
    y: 532.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1294.808 1336.4242)",
    className: "st4",
    width: 18,
    height: 270.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    className: "st5",
    d: "M569.9,587.4c-2.9-6.5,0-14.2,6.6-17.2c1.7-0.7,3.5-1.1,5.3-1.1c5.1,0,9.8,3,11.9,7.7L657.7,721 l-23.8,10.6L569.9,587.4z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_7_",
    x: 462.9,
    y: 532.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 943.8047 1336.4242)",
    className: "st4",
    width: 18,
    height: 270.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    className: "st6",
    d: "M546.2,550.5c-61.9,0-112-47.2-112-105.3c0-15,3.4-29.3,9.4-42.3 c-39.4,16.3-66.9,53.4-66.9,96.4c0,58.2,50.1,105.3,112,105.3c45.9,0,85.3-25.9,102.6-63C577.4,547.3,562.2,550.5,546.2,550.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_15_",
    className: "st7",
    cx: 484.2,
    cy: 522.7,
    rx: 61.3,
    ry: 56.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st8",
    d: "M373.8,532.8H236.7c-5.2,0-9.5-4.3-9.5-9.5v-9c0-5.2,4.3-9.5,9.5-9.5h137.1 c5.2,0,9.5,4.3,9.5,9.5v9C383.3,528.5,379,532.8,373.8,532.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st9",
    d: "M537.3,479.8c-19.2,0-34.8-15.6-34.8-34.8v-34.8c0-13.3-10.7-24-24-24h0V445 c0,32.5,26.3,58.8,58.8,58.8h48.7v-24H537.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st10",
    d: "M545.2,296.1c-3.6,45.5-43.6,95.9-81,89.5c-35.8-6.1-60.4-62.6-48.3-102.2 c7.5-24.4,28.1-39.7,44.7-52c17.2-12.8,28.8-21.4,42-19.3C528.8,216.1,548.1,259.9,545.2,296.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st11",
    d: "M494.7,425.6c-0.7-0.8-6.3-7.3-7.3-8.2c-2.6-10.7-7.9-22.5-6.8-36.3 c-7.5-5.5-19.9-12.5-34-11.5c-4.2,0.3-8.6,1.3-10.8,1.8c-12.2,2.8-19.9,7.3-22.4,8.8c-3.4,2.1-5.1,3.1-7.1,5.1 c-5.4,5.6-6.7,12.4-7.4,16.4c-6,34.8-1.3,68.2-0.7,71.1c1.1,5.3,2.6,10,2.6,10c2.5,7.9,5.5,12.8,6.3,15c4,10.8,13.1,33.5,22.7,50.8 c7,1.1,22.9,8.1,33.4,4.5c16-5.5,49-17.8,60.8-20.3c-14.7-16.5-28.2-34.9-31.7-57.3c-0.9-5.8-1.7-11.5-2.3-17.1 c1.4-0.7,9.9-5,11.6-13.6C503.4,435.5,496.1,427.2,494.7,425.6z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_48_",
    transform: "matrix(0.9632 -0.2686 0.2686 0.9632 -87.0603 136.0134)",
    className: "st9",
    cx: 453.5,
    cy: 386.1,
    rx: 16.4,
    ry: 19.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st10",
    d: "M450.9,363.4c5.5,13,14.6,17.5,20.4,20.9c11.3,6.6,32.5,6,32.5,6c0.7-4.6,1.4-8.6,5-16.2 c5.2-11.3,10-14,16.7-24.2c10-15.4,15-34,11.8-35.8c-2.3-1.4-8.6,5.8-12.7,10C512.9,336.1,486.7,353.9,450.9,363.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st9",
    d: "M450.5,392h-4.2c-9.2,0-16.6-7.4-16.6-16.6v-63.1h33.2v67.2C462.9,386.4,457.3,392,450.5,392z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_5_",
    x: 263.6,
    y: 532.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 545.1833 1336.4242)",
    className: "st4",
    width: 18,
    height: 270.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_96_",
    x: 374.3,
    y: 532.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 766.5938 1336.4242)",
    className: "st12",
    width: 18,
    height: 270.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_102_",
    x: 746.8,
    y: 532.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1511.5505 1336.4242)",
    className: "st12",
    width: 18,
    height: 270.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st13",
    d: "M429.7,319c2.2,19.1,15.4,34.9,33.2,40.9v-51.4h-33.2V319z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st5",
    d: "M478.5,357.4L478.5,357.4c-24.4,0-44.1-19.7-44.1-44.1v-53.8c0-2.3,1.8-4.1,4.1-4.1h62.7 c11.8,0,21.4,9.6,21.4,21.4v36.5C522.6,337.7,502.9,357.4,478.5,357.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st14",
    d: "M522.6,307c-0.5,1.2-1.7,2-3,2h-19.4c-1.8,0-3.3-1.5-3.3-3.3v-10.9c0-1.8,1.5-3.3,3.3-3.3h19.4 c1.3,0,2.5,0.8,3,2v-4.2c-0.9-0.5-1.9-0.8-3-0.8h-19.4c-3.5,0-6.3,2.8-6.3,6.3v10.9c0,3.5,2.8,6.3,6.3,6.3h19.4c1.1,0,2.1-0.3,3-0.8 V307z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st15",
    d: "M483.6,310.4h-19.4c-2.7,0-4.8-2.2-4.8-4.8v-10.9c0-2.7,2.2-4.8,4.8-4.8h19.4 c2.7,0,4.8,2.2,4.8,4.8v10.9C488.4,308.3,486.2,310.4,483.6,310.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st16",
    d: "M461.8,321.7v-53.8c0-2.3,1.8-4.1,4.1-4.1l36.2-12.7c-3.9-5.1,6,4.4-0.9,4.4h-62.7 c-2.3,0-4.1,1.8-4.1,4.1v53.8c0,24.4,19.7,44.1,44.1,44.1h0c0.5,0,1,0,1.6,0C469,349.4,461.8,336.4,461.8,321.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st17",
    d: "M519.6,308.4h-19.4c-2.7,0-4.8-2.2-4.8-4.8v-10.9c0-2.7,2.2-4.8,4.8-4.8h19.4 c2.7,0,4.8,2.2,4.8,4.8v10.9C524.4,306.3,522.2,308.4,519.6,308.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st18",
    d: "M490,335.2L490,335.2c-5.6,0-10.1-4.5-10.1-10v-4.7h20v4.7C499.9,330.7,495.5,335.2,490,335.2z "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_11_",
    className: "st19",
    x1: 471.9,
    y1: 296.9,
    x2: 480.9,
    y2: 296.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_22_",
    className: "st19",
    x1: 505.9,
    y1: 296.9,
    x2: 514.9,
    y2: 296.9
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st17",
    d: "M483.6,308.4h-19.4c-2.7,0-4.8-2.2-4.8-4.8v-10.9c0-2.7,2.2-4.8,4.8-4.8h19.4 c2.7,0,4.8,2.2,4.8,4.8v10.9C488.4,306.3,486.2,308.4,483.6,308.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st20",
    d: "M497,214.9c-12.1-15.6-32.7-15.3-36.5-15.7c-3.4-0.7-22.1,0.2-35.8,3.8 c-31.6,8.4-53.6,37-53.6,69.8v42c0,28.2,20.8,62.4,47.5,71.3c14.8,5,31.2,8.8,35.1,8.2c-19.8-36.7-17.1-58.4-11.5-71.1 c13.4-31,52.7-29.9,62.4-64.4C504.8,257.8,510.9,232.9,497,214.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st11",
    d: "M483.9,391.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st9",
    d: "M620.4,503.5c1-2.6,1.5-5.4,1.5-8.3c0-13.3-10.7-24-24-24c-13.3,0-24,10.7-24,24 c0,2.9,0.5,5.7,1.5,8.3H620.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st21",
    d: "M543.4,504.8c-2-9.2-13.1-16.2-26.6-16.2c-13.4,0-24.6,7-26.6,16.2H543.4z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_16_",
    className: "st9",
    cx: 411.7,
    cy: 411.9,
    rx: 14.6,
    ry: 22.9
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st5",
    d: "M455.9,480.6c-19.2,0-34.8-15.6-34.8-34.8v-42.5c0-6.6-5.4-12-12-12l0,0c-6.6,0-12,5.4-12,12 v42.5c0,32.5,26.3,58.8,58.8,58.8h48.7v-24h-24.4H455.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st22",
    d: "M658.1,504.8H546.1c-1.4,0-2.6-1.2-2.6-2.6l0,0c0-1.4,1.2-2.6,2.6-2.6h112.1 c1.4,0,2.6,1.2,2.6,2.6l0,0C660.8,503.6,659.6,504.8,658.1,504.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_76_",
    className: "st21",
    d: "M658.1,502.2H546.1c-1,0-1.8-0.5-2.3-1.3c-0.2,0.4-0.4,0.8-0.4,1.3c0,1.4,1.2,2.6,2.6,2.6 h112.1c1.4,0,2.6-1.2,2.6-2.6c0-0.5-0.1-0.9-0.4-1.3C659.9,501.6,659.1,502.2,658.1,502.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    className: "st21",
    d: "M567.8,504.8h-21.7c-1.4,0-2.6-1.2-2.6-2.6l0,0c0-1.4,1.2-2.6,2.6-2.6h21.7 c1.4,0,2.6,1.2,2.6,2.6l0,0C570.4,503.6,569.3,504.8,567.8,504.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_148_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    className: "st21",
    d: "M650.2,499.6H642v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    className: "st21",
    d: "M640.2,499.6H632v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_142_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_144_",
    className: "st21",
    d: "M630.2,499.6H622v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_139_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    className: "st21",
    d: "M620.2,499.6H612v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_136_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st21",
    d: "M610.2,499.6H602v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_133_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    className: "st21",
    d: "M600.2,499.6H592v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_130_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    className: "st21",
    d: "M590.2,499.6H582v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_127_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_129_",
    className: "st21",
    d: "M580.2,499.6H572v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_124_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    className: "st21",
    d: "M570.2,499.6H562v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_121_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    className: "st21",
    d: "M560.2,499.6H552v-1.9c0-1,0.8-1.9,1.9-1.9h4.4c1,0,1.9,0.8,1.9,1.9V499.6z"
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st23",
    d: "M546.1,504.8h21.7c1.4,0,2.6-1.2,2.6-2.6h-27C543.4,503.6,544.6,504.8,546.1,504.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st24",
    d: "M555.8,586h-79.1l-0.6-42h98c6.6,0,11.9,5.3,11.9,11.9v0C585.9,572.6,572.4,586,555.8,586z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_100_",
    className: "st9",
    d: "M492.2,738.3l48.5-164c1.6-5.5,6.7-9.3,12.5-9.3c1.2,0,2.5,0.2,3.7,0.5 c6.9,2,10.8,9.3,8.8,16.2l-48.5,164L492.2,738.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st24",
    d: "M532.5,724.9L492.2,713L543,541.3c3.3-11.1,15-17.5,26.1-14.2h0c11.1,3.3,17.5,15,14.2,26.1 L532.5,724.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st25",
    d: "M732.7,456.2h-168c-3.3,0-6-2.7-6-6l20.8-120c0-3.3,2.7-6,6-6h168c3.3,0,6,2.7,6,6l-20.8,120 C738.7,453.5,736.1,456.2,732.7,456.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st21",
    d: "M742.7,456.2h-168c-3.3,0-6-2.7-6-6l20.8-120c0-3.3,2.7-6,6-6h168c3.3,0,6,2.7,6,6l-20.8,120 C748.7,453.5,746.1,456.2,742.7,456.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st25",
    d: "M691.4,498.3l-13.8-69.9H653c-3,0-5.3,2.8-4.7,5.7l12.2,61.7c0.5,2.3-1.3,4.4-3.6,4.4h-15 c-2.7,0-4.8,2.2-4.8,4.8l0,0h25.2h0h23.4C689.4,505.1,692.1,501.8,691.4,498.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st21",
    d: "M692.7,505.1h-25.5l-14.8-75c-0.2-0.9,0.5-1.6,1.4-1.6h28.7l14.2,71.9 C697.1,502.8,695.2,505.1,692.7,505.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_38_",
    className: "st21",
    points: "662.4,505.1 667.2,505.1 665.9,498.3 661,498.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st25",
    d: "M662.4,505.1L662.4,505.1c2.5,0,4.4-2.3,3.9-4.8l-0.4-2h-5.4L662.4,505.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    className: "st25",
    d: "M684.4,392.6c-5.4,0-9.8-4.4-9.8-9.8c0-1.8,0.5-3.4,1.3-4.8c-1.4-0.4-2.9-0.7-4.5-0.7 c-8.5,0-15.3,6.9-15.3,15.3s6.9,15.3,15.3,15.3c8.5,0,15.3-6.9,15.3-15.3c0-0.1,0-0.2,0-0.3C685.9,392.5,685.2,392.6,684.4,392.6z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st7",
    d: "M568.1,563.1l-82.4,21.7c-22.4,5.9-45.1-10-56-36.3l127.7-26.1c11.2-2.9,22.7,3.8,25.6,15v0 C586,548.7,579.3,560.2,568.1,563.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st7",
    d: "M651,688.1l-38.4,17.1l-67.3-151.4c-4.7-10.6,0.1-23,10.7-27.7l0,0c10.6-4.7,23,0.1,27.7,10.7 L651,688.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st6",
    d: "M365.5,532.8h428.2c5.2,0,9.5-4.3,9.5-9.5v-9c0-5.2-4.3-9.5-9.5-9.5H365.5 c-5.2,0-9.5,4.3-9.5,9.5v9C356,528.5,360.2,532.8,365.5,532.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st26",
    d: "M713.6,736.8l-85.1,15.5c-3.3,0.6-6.4-1.5-7.1-4.6l-0.6-2.7c-1.7-7.8,3.3-15.7,11.5-17.8 l62-15.7c12-3,24.1,2.5,26.3,12.6l0.8,3.6C722.3,731.8,718.8,735.9,713.6,736.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    className: "st27",
    d: "M716.9,729.1l-95.1,17.3c-0.2,0-0.4,0.1-0.6,0.1l0.3,1.2c0.7,3.2,3.8,5.2,7.1,4.6l85.1-15.5 c5.2-0.9,8.8-5,7.9-9.1l-0.1-0.3C720.1,728.2,718.6,728.8,716.9,729.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    className: "st28",
    d: "M537.9,790.3l-71.1-49.2c-2.7-1.9-3.5-5.6-1.7-8.3l1.5-2.4c4.3-6.7,13.5-8.8,20.7-4.4 l54.9,32.8c10.7,6.4,15.3,18.9,9.7,27.5l-2,3.1C547.7,792.9,542.2,793.3,537.9,790.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st25",
    d: "M545.7,787.2l-79.5-55c-0.2-0.1-0.3-0.3-0.5-0.4l-0.6,1c-1.7,2.7-1,6.4,1.7,8.3l71.1,49.2 c4.3,3,9.8,2.6,12-0.9l0.2-0.3C548.6,788.8,547.1,788.1,545.7,787.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st29",
    d: "M341,504.8h-16.2c-8.2,0-14.9-6.7-14.9-14.9v-44.1h46v44.1C356,498.1,349.3,504.8,341,504.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    className: "st30",
    d: "M315.1,451.8c-10.7,0-19.3,8.7-19.3,19.3s8.7,19.3,19.3,19.3s19.3-8.7,19.3-19.3 S325.7,451.8,315.1,451.8z M315.1,486.2c-8.3,0-15.1-6.8-15.1-15.1c0-8.3,6.8-15.1,15.1-15.1c8.3,0,15.1,6.8,15.1,15.1 C330.1,479.5,323.4,486.2,315.1,486.2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    className: "st31",
    d: "M341,504.8h-16.2c-8.2,0-14.9-6.7-14.9-14.9v-44.1h46v44.1C356,498.1,349.3,504.8,341,504.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    className: "st32",
    d: "M331.7,490.8c-4.6,0-8.3-3.7-8.3-8.3v-36.7h-13.5v44.1c0,8.2,6.7,14.9,14.9,14.9H341 c7.9,0,14.4-6.2,14.9-14H331.7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st5",
    d: "M522.4,504.8c1-2.6,1.5-5.4,1.5-8.3c0-13.3-10.7-24-24-24c-13.3,0-24,10.7-24,24 c0,2.9,0.5,5.7,1.5,8.3H522.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st11",
    d: "M393.3,391.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_12_",
    className: "st33",
    cx: 327.9,
    cy: 431.3,
    r: 6.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_43_",
    className: "st33",
    cx: 339.9,
    cy: 408.6,
    r: 9.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_45_",
    className: "st3",
    cx: 245,
    cy: 328.1,
    r: 27.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.06cedb0c77e2891da2a729984dba7c2e.svg";
export { ForwardRef as ReactComponent };